import { collection, getDocs, orderBy, query } from "firebase/firestore";

import { db } from "@/firebase/firebase-config";

export async function fetchLessonsForDomain(domainId: string) {
  console.log(`[fetchLessonsForDomain] Starting fetch for domain: ${domainId}`);
  const lessonsRef = collection(db(), "curriculum", domainId, "lessons");
  const lessonsQuery = query(lessonsRef, orderBy("order", "asc"));
  
  try {
    const snapshot = await getDocs(lessonsQuery);
    console.log(`[fetchLessonsForDomain] Received ${snapshot.docs.length} lessons from Firestore`);

    return snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        level: (data.level || "").toLowerCase(),
      };
    });
  } catch (error) {
    console.error(`[fetchLessonsForDomain] Error fetching from Firestore:`, error);
    throw error;
  }
}
